import type { ReactNode } from 'react'

/**
 * A screen that stands outside the navigation frame.
 *
 * There are only a few of these — the way in, an account that was turned away, a MyLib that is not
 * answering, a session that has ended — and they all have the same shape: one column, one card, no
 * navigation, because there is nothing yet to navigate.
 */
export function Screen({ children }: { readonly children: ReactNode }) {
  return (
    <main className="page">
      <h1 className="page__title">MyLib</h1>
      <section className="card">{children}</section>
    </main>
  )
}
